(function(){
  const root = document.querySelector('[data-apm-product-tabs]');
  if(!root) return;

  // 対象グリッド（検索/コレクションのどちらでも拾えるように複数候補）
  const grids = document.querySelectorAll('.product-grid, .grid--view-items, .collection__grid, .grid');
  if(!grids.length) return;

  const tabs = root.querySelectorAll('.product-tabs__tab');

  // URLから初期値を取得
  const params = new URL(window.location.href).searchParams;
  const initial = (params.get('product') || '').trim(); // "" のときは全て

  // タブのUI状態更新
  function setActive(value){
    tabs.forEach((t,i)=>{
      const v = t.dataset.value || '';
      const on = (v === (value||''));
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
  }

  // グリッド絞り込み
  function filter(value){
    grids.forEach(grid=>{
      const items = grid.querySelectorAll('[data-product]');
      items.forEach(it=>{
        const p = (it.getAttribute('data-product') || '').trim();
        const show = !value || value === 'all' || p === value;
        it.classList.toggle('is-hidden', !show);
      });
    });
  }

  // 履歴更新（?product=xxx）
  function updateURL(value){
    const url = new URL(location.href);
    if(!value){ url.searchParams.delete('product'); }
    else { url.searchParams.set('product', value); }
    history.replaceState(null, '', url.toString());
  }

  // 初期化
  setActive(initial);
  filter(initial);

  // クリック/キーボード
  tabs.forEach(tab=>{
    tab.addEventListener('click', ()=>{
      const v = tab.dataset.value || '';
      setActive(v);
      filter(v);
      updateURL(v);
    });
    tab.addEventListener('keydown', (e)=>{
      if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const a = Array.from(tabs);
      const idx = a.indexOf(tab);
      const next = e.key === 'ArrowRight' ? (idx+1) % a.length : (idx-1+a.length)%a.length;
      a[next].focus(); a[next].click();
    });
  });
})();
